import React, { Component } from 'react';
import PropTypes from 'prop-types';
// ---
// import ReactSlider from './react-slick'
import ReactSlider from 'react-slick';
// ---
import { withRadium, DetectCompact } from '../../higher-order-components'
// ---
import Wrapper from '../../components/wrapper';
import HeroImage from '../hero-image';
import HeroVideo from '../hero-video';
import PhotoInfo from '../photo-info';
import RelatedVideo from '../related-video';
// import Html from '../html';
// import Slider from '../../containers/slider';
// ---
import './styles.css';
import { eventWithPoint, Vectors } from "../../utils";

/**
 * slick slider 拡張 Slider
 * @param {Array<Component>} children child component list
 * @param {*} settings react-slick option
 * @param {function} photoInfoWillOpen {@link PhotoInfo} open callback
 * @param {function} photoInfoWillClose {@link PhotoInfo} close callback
 * @param {function} modalWillOpen {@link HeroVideo} modal open callback
 * @param {function} modalWillClose {@link HeroVideo} modal close callback
 * @param {boolean} inHeroCarousel parent {@link HeroCarousel} flag - `HeroVideo` autoPlay 振舞いが異なるために使用します
 * @param {string} heroCarouselSlideId 現在カレントの slider ID - `containerId`
 * @param {Array<string>} idList slider child 識別子リスト
 * @param {function} sendMessage figureBlock rect を通知する関数
 * @returns {ReactElement} react-slick slider component
 * @see https://github.com/akiran/react-slick
 */
const Slider = ({
  children,
  // compact,
  settings,
  photoInfoWillOpen,
  photoInfoWillClose,
  modalWillOpen,
  modalWillClose,
  inHeroCarousel,
  heroCarouselSlideId,
  idList,
  sendMessage,
}) => (
  // props 拡張するために component を生成する
  <ReactSlider {...settings}>
    {
      children.map((child, i) => {
        // clone 作成
        const props = Object.assign({}, child.props);
        // console.log('ReactSlider props ', i, idList[i]);
        // PhotoInfo component 作成
        if (Array.isArray(props.photoInfo)) {
          props.photoInfo = props.photoInfo.map(photoInfo => (
            <PhotoInfo
              key={`HeroCarousel-${photoInfo.props.containerId}`}
              {...photoInfo.props}
              photoInfoWillOpen={photoInfoWillOpen}
              photoInfoWillClose={photoInfoWillClose}
              inHeroCarousel={inHeroCarousel}
              heroCarouselSlideId={heroCarouselSlideId}
            />
          ));
        }
        // check displayName
        // if (child.type.displayName === 'withDynamicComponents(HeroImage)') {
        if (0 <= child.type.displayName.indexOf('withDynamicComponents(HeroImage)')) {
          // HeroImage
          return <HeroImage
            key={`HeroCarousel-HeroImage-${props.containerId}`}
            {...props}
            photoInfoWillOpen={photoInfoWillOpen}
            photoInfoWillClose={photoInfoWillClose}
            modalWillOpen={modalWillOpen}
            modalWillClose={modalWillClose}
            inHeroCarousel={inHeroCarousel}
            heroCarouselSlideId={heroCarouselSlideId}
            heroCarouselUniqueId={idList[i]}
            sendMessage={sendMessage}
          />
        // } else if (child.type.displayName === 'withDynamicComponents(HeroVideo)') {
        } else if (0 <= child.type.displayName.indexOf('withDynamicComponents(HeroVideo)')) {
          // HeroVideo > RelatedVideo
          if (Array.isArray(props.relatedVideo)) {
            props.relatedVideo = props.relatedVideo.map((relatedVideo, index) => {
              // console.log('props.relatedVideo', relatedVideo);
              if (relatedVideo.name === 'RelatedVideo') {
                return (
                  <RelatedVideo
                    key={`HeroCarousel-HeroVideo-relatedVideo-${relatedVideo.props.containerId}`}
                    {...relatedVideo.props}
                  />
                );
              }
              return null;
            }).filter(component => (component !== null));
          }
          // HeroVideo
          return <HeroVideo
            key={`HeroCarousel-HeroVideo-${props.containerId}`}
            {...props}
            photoInfoWillOpen={photoInfoWillOpen}
            photoInfoWillClose={photoInfoWillClose}
            modalWillOpen={modalWillOpen}
            modalWillClose={modalWillClose}
            inHeroCarousel={inHeroCarousel}
            heroCarouselSlideId={heroCarouselSlideId}
            heroCarouselUniqueId={idList[i]}
            sendMessage={sendMessage}
          />
        }
        return null;
      })
    }
  </ReactSlider>
);

Slider.propTypes = {
  children: PropTypes.arrayOf(PropTypes.node.isRequired).isRequired,
  // compact: PropTypes.bool.isRequired,
  settings: PropTypes.object.isRequired,
  photoInfoWillOpen: PropTypes.func.isRequired,
  photoInfoWillClose: PropTypes.func.isRequired,
  modalWillOpen: PropTypes.func.isRequired,
  modalWillClose: PropTypes.func.isRequired,
  inHeroCarousel: PropTypes.bool.isRequired,
  heroCarouselSlideId: PropTypes.string.isRequired,
  sendMessage: PropTypes.func.isRequired,
};

withRadium(DetectCompact())(Slider);

/**
 * HeroCarousel - carousel 実装します
 * - {@link Slider}
 * - `react-slick` - `slick` 依存します
 * @see https://github.com/akiran/react-slick
 * @see http://kenwheeler.github.io/slick/
 */
export default class HeroCarousel extends Component {
  static propTypes = {
    containerId: PropTypes.string,
    containerClass: PropTypes.string,
    autoplay: PropTypes.bool,
    duration: PropTypes.number,
    pcSize: PropTypes.string,
    mbSize: PropTypes.string,
    scrollToSlug: PropTypes.bool,
    components: PropTypes.arrayOf(PropTypes.node),
  };
  static defaultProps = {
    containerId: null,
    containerClass: null,
    autoplay: null,
    duration: null,
    pcSize: null,
    mbSize: null,
    scrollToSlug: null,
    components: null,
  };
  
  constructor(props) {
    super(props);
    // ---
    // const { children } = props;
    const children = Array.isArray(props.children) ? props.children: [];
    const length = children.length;
    // console.log('HeroCarousel', children, length);
    const index = 0;
    /**
     * slider children `containerId` list
     * @type {string[]}
     */
    this.idList = children.map((child, i) => (`HeroCarousel-${i}`));
    // console.log('HeroCarousel', this.idList, children);
    // ---
    /**
     * children length
     * @type {number}
     */
    this.length = length;
    /**
     * slick object - mount 後に設定されます
     * @type {?slick}
     */
    this.slider = null;
    const buttons = Array(length).fill('');
    // const buttons = Array(length).keys().map(() => (''));
    buttons[index] = 'is-active';
    /**
     * bound onClickPager - pager click handler
     * @type {bound|any}
     */
    this.onClickPager = this.onClickPager.bind(this);
    /**
     * bound onClickNext - next button click handler
     * @type {bound|any}
     */
    this.onClickNext = this.onClickNext.bind(this);
    /**
     * bound onClickPrev - prev button click handler
     * @type {bound|any}
     */
    this.onClickPrev = this.onClickPrev.bind(this);
    // /**
    //  * bound onAfterChange - slick afterChange callback
    //  * @type {bound|any}
    //  */
    // this.onAfterChange = this.onAfterChange.bind(this);
    /**
     * bound onBeforeChange - slick beforeChange callback
     * @type {bound|any}
     */
    this.onBeforeChange = this.onBeforeChange.bind(this);
    /**
     * 現在 slide No.
     * @type {number}
     */
    this.index = index;
    /**
     * `.slick-track` > slide nodes
     * @type {Array.<Element>}
     */
    this.children = children;
    /**
     * modal open class
     * @type {string}
     */
    this.modalOpened = 'HeroVideo__modal__opened';
    /**
     * photo info open 時に body へ設定される class - `.PhotoInfo__opened`
     */
    this.infoOpened = 'PhotoInfo__opened';
    /**
     * autoPlay flag
     * @type {boolean}
     */
    this.isAutoPlay = !!props.autoplay;
    /**
     * `requestAnimationFrame` id - cancel 時に使用します
     * @type {number}
     */
    this.cycleId = 0;
    /**
     * carousel pause flag
     * @type {boolean}
     */
    this.paused = false;
    // /**
    //  * bound onCycle
    //  * @type {bound|any}
    //  */
    // this.onCycle = this.onCycle.bind(this);
    /**
     * bind photoInfoWillOpen - {@link PhotoInfo} open callback
     * @type {bound|any}
     */
    this.photoInfoWillOpen = this.photoInfoWillOpen.bind(this);
    /**
     * bind photoInfoWillClose - {@link PhotoInfo} close callback
     * @type {bound|any}
     */
    this.photoInfoWillClose = this.photoInfoWillClose.bind(this);
    /**
     * bind modalWillOpen - {@link HeroVideo} modal open callback
     * @type {bound|any}
     */
    this.modalWillOpen = this.modalWillOpen.bind(this);
    /**
     * bind modalWillClose - {@link HeroVideo} modal close callback
     * @type {bound|any}
     */
    this.modalWillClose = this.modalWillClose.bind(this);
    // this.onSwipe = this.onSwipe.bind(this);
    /**
     * bind onTouchStart
     * @type {bound|any}
     */
    this.onTouchStart = this.onTouchStart.bind(this);
    // this.onTouchMove = this.onTouchMove.bind(this);
    /**
     * bind onTouchEnd
     * @type {bound|any}
     */
    this.onTouchEnd = this.onTouchEnd.bind(this);
    /**
     * bind onTouchCancel
     * @type {bound|any}
     */
    this.onTouchCancel = this.onTouchCancel.bind(this);
    /**
     * swipe 判定用の touch position values
     * @type {{start: Vectors, end: Vectors}}
     */
    this.vectors = {
      start: new Vectors(),
      end: new Vectors(),
    };
    /**
     * swipe 閾値
     * @type {number}
     * @default 5
     */
    this.swipeThreshold = 5;
    this.modalIsOpen = false;
    this.slick = {
      speed: 1000,
      // speed: 0,
      autoSpeedSecond: 5,
    };
    // this.onArrowPrevTransitionEnd = this.onArrowPrevTransitionEnd.bind(this);
    // this.onArrowNextTransitionEnd = this.onArrowNextTransitionEnd.bind(this);
    // this.onMaskTransitionEnd = this.onMaskTransitionEnd.bind(this);
    this.transitionClasses = {
      mask: 'HeroCarousel__mask__fadein',
      maskFaster: 'HeroCarousel__mask__fadein__faster',
      maskOut: 'HeroCarousel__mask__fadeout',
      maskGone: '',
      click: 'HeroCarousel__btn__clicked',
      blink: 'HeroCarousel__btn__blink',
    };
    this.timer = {
      mask: 0,
      maskOut: 0,
      lazy: 0,
      slick: 0,
      arrow: 0,
      state: 0,
      intro: 0,
    };
    // this.onLazyLoad = this.onLazyLoad.bind(this);
    /**
     * React.state
     * - buttons - {string[]} - pager state - current 時に `is-active` 設定します
     * @type {{
     *  buttons: any[],
     *  heroCarouselSlideId: string,
     *  maskClass: string,
     *  arrowPrevClass: string,
     *  arrowNextClass: string,
     *  transitionStart: boolean,
     *  transitionMaskStart: boolean,
     * }}
     */
    this.state = {
      buttons,
      heroCarouselSlideId: this.idList[0] || '',
      // ---
      transitionStart: false,
      transitionMaskStart: false,
      maskClass: this.transitionClasses.maskGone,
      arrowPrevClass: '',
      arrowNextClass: '',
      introClass: '',
      figureHeight: 0,
      // ---
      requestMessageFlag: false,
    };
    this.slickStarted = false;
    this.buttons = buttons;
    this.heroCarouselSlideId = this.state.heroCarouselSlideId;
    this.transitionDelay = 480;
    /**
     * intro 終わるまで click 無効にする flag
     * @type {boolean}
     */
    this.enableUi = true;
    // this.enableUi = false;
    this.receiveMessage = this.receiveMessage.bind(this);
    this.figureList = {};
  }
  
  // --------------------------------------
  /**
   * mask へ `figure-block` の高さを設定するための callback
   * - {@link HeroImage} / {@link HeroVideo} から通知されます
   * - `heroCarouselSlideId` をもとに {@link HeroCarousel.figureList} へ設定します
   * @param {string} heroCarouselSlideId carousel id
   * @param {*} rect ClientRect
   */
  receiveMessage(heroCarouselSlideId, rect) {
    this.figureList[heroCarouselSlideId] = rect;
    // console.log('HeroCarousel.receiveMessage', heroCarouselSlideId, rect, this.figureList);
  }
  
  /**
   * state value へ {@link HeroCarousel.figureList} から height value を取り出し設定し返します
   * @param {*} state React.state
   * @returns {*} React.state
   */
  updateStateFigureHeight(state) {
    const rect = this.figureList[this.heroCarouselSlideId];
    state.figureHeight = (rect && rect.height) ? rect.height: 0;
    return state;
  }
  
  // --------------------------------------
  /**
   * {@link PhotoInfo} open callback
   * - auto play flag On -> pause
   */
  photoInfoWillOpen() {
    this.autoPlayWithPause();
  }
  
  /**
   * {@link PhotoInfo} close callback
   * - auto play flag On -> play
   */
  photoInfoWillClose() {
    this.autoPlayWithPlay();
  }
  
  /**
   * {@link HeroVideo} modal open callback
   * - auto play flag On -> pause
   */
  modalWillOpen() {
    this.autoPlayWithPause();
    this.modalIsOpen = true;
  }
  
  /**
   * {@link HeroVideo} modal close callback
   * - auto play flag On -> play
   */
  modalWillClose() {
    this.autoPlayWithPlay();
    this.modalIsOpen = false;
  }
  
  // --------------------------------------
  /**
   * autoPlay flag true の時に slick pause します
   */
  autoPlayWithPause() {
    if (this.isAutoPlay) {
      // console.log('HeroCarousel.autoPlayWithPause', this.isAutoPlay, Date.now());
      this.slickPause();
    }
  }
  
  /**
   * autoPlay flag true の時に slick play します
   */
  autoPlayWithPlay() {
    if (this.isAutoPlay) {
      // console.log('HeroCarousel.autoPlayWithPlay', this.isAutoPlay, Date.now());
      this.slickPlay();
    }
  }
  
  /**
   * slick slider pause
   */
  slickPause() {
    this.paused = true;
    if (this.slider) {
      this.slider.slickPause();
    }
  }
  
  /**
   * slick slider play
   */
  slickPlay() {
    this.paused = false;
    if (this.slider) {
      this.slider.slickPlay();
    }
  }
  
  // --------------------------------------
  /**
   * touch move value を初期化します
   */
  resetMove() {
    const { start, end } = this.vectors;
    start.reset();
    end.reset();
  }
  
  /**
   * touchstart event handler
   * @param {Event} event touch event
   */
  onTouchStart(event) {
    // console.log('HeroCarousel.onTouchStart', this.enableUi);
    if (!this.modalIsOpen) {
      this.resetMove();
      this.vectors.start.updateWithVectors(eventWithPoint(event));
    }
  }
  // onTouchMove(event) {
  //     console.log('HeroCarousel.onTouchMove', event);
  //     // this.vectors.end = eventWithPoint(event);
  //     // const distanceX = this.vectors.end.distanceX(this.vectors.start);
  // }
  /**
   * touchend event handler
   * - swipe 実行判定します
   * @param {Event} event touch event
   */
  onTouchEnd(event) {
    // console.log('HeroCarousel.onTouchEnd', event);
    if (!this.modalIsOpen) {
      this.vectors.end.updateWithVectors(eventWithPoint(event));
      const distanceX = this.vectors.end.distanceX(this.vectors.start);
      // console.log('HeroCarousel.onTouchEnd', distanceX);
      if (Math.abs(distanceX) >= this.swipeThreshold) {
        if (distanceX < 0) {
          // left
          this.slickNext();
        } else {
          // right
          this.slickPrev();
        }
      }
      this.resetMove();
    }
  }
  
  /**
   * touchCancel event handler
   */
  onTouchCancel() {
    // console.log('HeroCarousel.onTouchCancel');
    this.resetMove();
  }
  
  // --------------------------------------
  /**
   * slick beforeChange callback
   * - pager current class を設定します
   * - slick - afterChange callback 不定期にしか来ないので使わない <- bug?
   * @param {number|string} current 変更前のスライド番号 - always `undefined` <- bug?
   * @param {number|string} next 変更後のスライド番号 - pager current に使用します
   */
  onBeforeChange(current, next) {
    // const {
    //   transitionMaskStart,
    // } = this.state;
    // if (!transitionMaskStart) {
    //   this.transitionMaskFadeInOut(true);
    // }
    this.isTransitionMaskFadeInOut(true);
    this.resetTransitionTimer();
    // ---
    const index = parseInt(next, 10);
    const result = this.currentIndex(index);
    // console.log('HeroCarousel.onBeforeChange', current, next, result, index, this.heroCarouselSlideId);
    if (result) {
      // // this.enableUi = false;
      // const state = {
      //   buttons: this.buttons,
      //   heroCarouselSlideId: this.heroCarouselSlideId,
      //   requestMessageFlag: !this.state.requestMessageFlag,
      // };
      // // for mask height
      // // refresh state
      // this.setState(this.updateStateFigureHeight(state));
      this.slickChangeWithStateUpdate();
    }
  }
  slickChangeWithStateUpdate() {
    // this.enableUi = false;
    const state = {
      buttons: this.buttons,
      heroCarouselSlideId: this.heroCarouselSlideId,
      requestMessageFlag: !this.state.requestMessageFlag,
    };
    // for mask height
    // refresh state
    this.setState(this.updateStateFigureHeight(state));
  }
  isTransitionMaskFadeInOut(faster = false) {
    const {
      transitionMaskStart,
    } = this.state;
    if (!transitionMaskStart) {
      this.transitionMaskFadeInOut(faster);
    }
  }
  transitionMaskFadeInOut(faster = false) {
    // this.enableUi = false;
    // ---
    this.resetTransitionTimer();
    // ---
    this.setState({
      transitionStart: false,
      transitionMaskStart: true,
      arrowNextClass: this.transitionClasses.click,
      arrowPrevClass: this.transitionClasses.blink,
      maskClass: faster ? this.transitionClasses.maskFaster: this.transitionClasses.mask,
    });
    const delay = (faster ? 480: 1000) + 32;
    this.delayFadeoutMaskClass(delay);
    this.delayClearArrowClass();
  }
  
  /**
   * `button.HeroCarousel__pager__dot` click event handler
   * - slick.slickGoTo 実行し slide を移動します
   * @param {Event} event click Event
   */
  onClickPager(event) {
    event.preventDefault();
    // // ---
    // if (!this.enableUi) {
    //   return;
    // }
    // this.enableUi = false;
    // ---
    const target = event.target.nodeName.toLowerCase() === 'button' ? event.target: event.target.parentNode;
    const index = parseInt(target.dataset.index, 10);
    const result = this.currentIndex(index);
    // index 更新していない時は移動しない
    // console.log('HeroCarousel.onClickPager', result, index, this.index);
    if (result) {
      this.isTransitionMaskFadeInOut(true);
      this.resetTransitionTimer();
      this.slickGoTo(index);
    }
  }
  
  /**
   * `button.HeroCarousel__next` click event handler
   * - slick.slickNext を実行し next slide に移動します
   * @param {Event} event click Event
   */
  onClickNext(event) {
    event.preventDefault();
    // console.log('HeroCarousel.onClickNext', this.enableUi);
    // if (!this.enableUi) {
    //   return;
    // }
    // ---
    this.slickNext();
  }
  
  /**
   * `button.HeroCarousel__prev` click event handler
   * - slick.slickPrev を実行し prev slide に移動します
   * @param {Event} event click Event
   */
  onClickPrev(event) {
    event.preventDefault();
    // if (!this.enableUi) {
    //   return;
    // }
    // ---
    this.slickPrev();
  }
  
  slickGoTo(index, delay = this.transitionDelay) {
    this.resetTransitionTimer();
    const slider = this.slider;
    if (slider) {
      clearTimeout(this.timer.slick);
      // this.enableUi = false;
      this.timer.slick = setTimeout(() => {
        slider.slickGoTo(index);
        this.setState({ heroCarouselSlideId: this.heroCarouselSlideId });
      }, delay);
      // slider.slickGoTo(index);
      this.photoInfoRemove();
      // ---
      // console.log('HeroCarousel.slickGoTo', index);
      const state = {
        transitionStart: false,
        transitionMaskStart: true,
        arrowNextClass: this.transitionClasses.blink,
        arrowPrevClass: this.transitionClasses.blink,
        maskClass: this.transitionClasses.mask,
        buttons: this.buttons,
        requestMessageFlag: !this.state.requestMessageFlag,
        // heroCarouselSlideId: this.heroCarouselSlideId,
      };
      this.setState(this.updateStateFigureHeight(state));
      this.delayFadeoutMaskClass();
      this.delayClearArrowClass();
    }
  }
  
  /**
   * slick.slickNext を実行し next slide に移動します
   * @param {number} [delay=this.transitionDelay] delay ms
   */
  slickNext(delay = this.transitionDelay) {
    // console.log('HeroCarousel.slickNext +++', delay);
    this.resetTransitionTimer();
    this.clearArrowClass();
    const slider = this.slider;
    if (slider) {
      // this.enableUi = false;
      this.timer.slick = setTimeout(() => {
        slider.slickNext();
      }, delay);
      // slider.slickNext();
      this.photoInfoRemove();
      // ---
      // console.log('HeroCarousel.slickNext');
      this.timer.state = setTimeout(() => {
        const state = {
          transitionStart: true,
          transitionMaskStart: true,
          arrowNextClass: this.transitionClasses.click,
          arrowPrevClass: this.transitionClasses.blink,
          maskClass: this.transitionClasses.mask,
          requestMessageFlag: !this.state.requestMessageFlag,
        };
        this.setState(this.updateStateFigureHeight(state));
        this.delayFadeoutMaskClass();
        this.delayClearArrowClass();
      }, 32);
    }
  }
  
  /**
   * slick.slickPrev を実行し prev slide に移動します
   * @param {number} [delay=this.transitionDelay] delay ms
   */
  slickPrev(delay = this.transitionDelay) {
    // console.log('HeroCarousel.slickPrev ---');
    this.resetTransitionTimer();
    this.clearArrowClass();
    const slider = this.slider;
    if (slider) {
      // this.enableUi = false;
      this.timer.slick = setTimeout(() => {
        slider.slickPrev();
      }, delay);
      // slider.slickPrev();
      this.photoInfoRemove();
      // ---
      // console.log('HeroCarousel.slickPrev');
      this.timer.state = setTimeout(() => {
        const state = {
          transitionStart: true,
          transitionMaskStart: true,
          arrowNextClass: this.transitionClasses.blink,
          arrowPrevClass: this.transitionClasses.click,
          maskClass: this.transitionClasses.mask,
          requestMessageFlag: !this.state.requestMessageFlag,
        };
        this.setState(this.updateStateFigureHeight(state));
        this.delayFadeoutMaskClass();
        this.delayClearArrowClass();
      }, 32);
    }
  }
  
  // --------------------------------------
  /**
   * transition mask fadeout class を付与します
   * - use - {@link HeroCarousel.transitionClasses.maskOut}
   * - reserve - {@link HeroCarousel.delayGoneMaskClass}
   * @param {number} [delay=1032] fadein time 1000ms + 2frame
   */
  delayFadeoutMaskClass(delay = 1032) {
    // console.log('HeroCarousel.delayFadeoutMaskClass', delay, this.timer);
    clearTimeout(this.timer.mask);
    this.timer.mask = setTimeout(() => {
      this.setState({
        maskClass: this.transitionClasses.maskOut,
        transitionMaskStart: false,
      });
      this.delayGoneMaskClass();
    }, delay);
  }
  
  /**
   * transition mask class remove
   * @param {number} [delay=1000] 遅延 time
   */
  delayGoneMaskClass(delay = 1000) {
    clearTimeout(this.timer.maskOut);
    this.timer.maskOut = setTimeout(() => {
      // this.enableUi = true;
      this.setState({
        maskClass: this.transitionClasses.maskGone,
        transitionMaskStart: false,
        figureHeight: 0,
      });
    }, delay);
  }
  
  clearArrowClass() {
    // console.log('HeroCarousel.clearArrowClass');
    // clearTimeout(this.timer.arrow);
    // this.timeoutAll();
    this.setState({ transitionStart: false, arrowPrevClass: '', arrowNextClass: '' });
  }
  
  delayClearArrowClass(delay = 1750) {
    clearTimeout(this.timer.arrow);
    this.timer.arrow = setTimeout(() => {
      this.clearArrowClass();
    }, delay);
  }
  
  // --------------------------------------
  /**
   * body から `.PhotoInfo__opened` 削除します
   */
  photoInfoRemove() {
    document.body.classList.remove(this.infoOpened);
  }
  
  /**
   * index を更新し pager current を設定します
   * - 現在 index と違う時のみ更新処理を行います
   * - state.buttons 更新します
   * @param {number} index slide index
   * @returns {boolean} true: 更新可能
   */
  currentIndex(index) {
    // console.log('HeroCarousel.currentIndex', index, this.index);
    // 現在 index と違う時のみ更新処理を行います
    if (index === this.index) {
      return false;
    }
    this.index = index;
    const buttons = Array(this.length).fill('');
    buttons[index] = 'is-active';
    // ---
    // slider id を update し child component へ通知する
    const heroCarouselSlideId = this.idList[index];
    // ---
    // this.setState({ buttons, heroCarouselSlideId });
    this.buttons = buttons;
    this.heroCarouselSlideId = heroCarouselSlideId;
    return true;
  }
  
  // --------------------------------------
  // /**
  //  * @deprecated instead use dispose or timeOut each
  //  */
  // timeoutAll() {
  //   Object.values(this.timer).map(id => (setTimeout(id)));
  // }

  resetTransitionTimer() {
    this.dispose();
  }
  /**
   * memory clear
   * - timerId clear all
   */
  dispose() {
    Object.values(this.timer).map(id => (setTimeout(id)));
  }
  // --------------------------------------
  shouldSlickAutoPlay() {
    // console.log('HeroCarousel.shouldSlickAutoPlay');
    this.autoPlayWithPlay();
    // this.enableUi = true;
  }
  
  // --------------------------------------
  /**
   * delegate - will unmount
   * - onCycle cancel します
   */
  componentWillUnmount() {
    // this.timeoutAll();
    this.dispose();
  }
  
  /**
   * delegate - after mount
   */
  componentDidMount() {
    this.autoPlayWithPause();
    this.setState({ introClass: 'HeroCarousel__started' });
    this.timer.intro = setTimeout(() => {
      this.shouldSlickAutoPlay();
    }, 3160);
  }
  
  // --------------------------------------
  /**
   * pager button を作成します
   * @returns {?Element[]} `button.HeroCarousel__pager__dot` list を返します
   */
  renderPagerButtons() {
    return Array(this.length).fill(0).map((value, index) => {
      const key = `pager-${index}`;
      return (
        <button
          key={key}
          type="button"
          className={`HeroCarousel__pager__dot ${this.state.buttons[index]}`}
          data-index={index}
          onClick={this.onClickPager}
        >
          <span/>
        </button>
      );
    });
  }
  
  /**
   * `div.HeroCarousel__pager__wrap` + `button.HeroCarousel__pager__dot` 作成します
   * @returns {?Element} pager - `div.HeroCarousel__pager__wrap`
   */
  renderPager() {
    if (this.length <= 1) {
      return null;
    }
    // ---
    return (
      <div className="HeroCarousel__pager__wrap">
        <div className="HeroCarousel__pager__block">
          <div className="HeroCarousel__pager">
            {
              this.renderPagerButtons()
            }
          </div>
        </div>
      </div>
    );
  }
  
  /**
   * prev / next arrow buttons 作成します
   * @returns {?Element} `.HeroCarousel__controls` container
   */
  renderControls() {
    if (this.length <= 1) {
      return null;
    }
    // ---
    const {arrowPrevClass, arrowNextClass} = this.state;
    // console.log('HeroCarousel.renderControls', arrowPrevClass, arrowNextClass);
    // ---
    return (
      <div className="HeroCarousel__controls">
        <button
          type="button"
          className={`HeroCarousel__btn HeroCarousel__prev ${arrowPrevClass}`}
          onClick={this.onClickPrev}
        >
          <i/>
        </button>
        <button
          type="button"
          className={`HeroCarousel__btn HeroCarousel__next ${arrowNextClass}`}
          onClick={this.onClickNext}
        >
          <i/>
        </button>
      </div>
    );
  }
  
  renderMask() {
    const { maskClass, figureHeight } = this.state;
    const styles = figureHeight ? { style: { height: `${figureHeight}px` } }: null;
    // console.log('HeroCarousel.renderMask', maskClass, figureHeight);
    return <div
      className={`HeroCarousel__mask ${maskClass}`}
      {...styles}
    />;
  }
  
  // /**
  //  * `.slick-track` children を取得し {@link HeroCarousel.children} へ設定します
  //  * @returns {boolean} true: 取得成功
  //  */
  // choseChildren() {
  //     const slider = this.slider;
  //     console.log('HeroCarousel.choseChildren', slider);
  //     // const innerSlider = slider.innerSlider || {};
  //     // const list = innerSlider.list || {};
  //     // const childNodes = list.childNodes || [];
  //     // if (!childNodes.length) {
  //     //     return false;
  //     // }
  //     // const nodes = childNodes[0];
  //     // if (!nodes || !nodes.childNodes || !nodes.childNodes.length) {
  //     //     return false;
  //     // }
  //     // // this.childNodes = nodes.childNodes;
  //     // this.children = Array.from(nodes.childNodes);
  //     // return true;
  // }
  /**
   * carousel container - `.HeroCarousel` を作成します
   * - `react-slick` で carousel を作成します
   * @returns {?Element} HeroCarousel container を返します
   * @see https://github.com/akiran/react-slick
   */
  render() {
    // ---
    if (!this.length) {
      return null;
    }
    const {
      containerId,
      containerClass,
      autoplay,
      duration,
      pcSize,
      mbSize,
      scrollToSlug,
      children,
    } = this.props;
    // ---
    // react-slick - @see https://react-slick.neostack.com/docs/api/
    // autoplaySpeed - カルーセルのオートプレイの秒数設定（秒）
    // @see https://react-slick.neostack.com/docs/api/#autoplaySpeed
    // milli seconds convert - default 3sec.
    const autoplaySpeed = (parseFloat(duration) || this.slick.autoSpeedSecond) * 1000;
    // autoplay - カルーセルのオートプレイ設定
    // @see https://react-slick.neostack.com/docs/api/#autoplay
    const settings = {
      // 1000
      speed: this.slick.speed,
      lazyLoad: 'progressive',
      arrows: false,
      autoplay: !!autoplay,
      // autoplay: false,
      ref: (component) => (this.slider = component),
      // afterChange: this.onAfterChange,
      beforeChange: this.onBeforeChange,
      // onLazyLoad: this.onLazyLoad,
      // ---
      onSwipe: this.onSwipe,
      // ---
      adaptiveHeight: true,
      slidesToShow: 1,
      fade: true,
      initialSlide: 0,
      // ---
      // swipeToSlide: true,
      // swipe: true,
      // touchMove: true,
      // useTransform: true,
      // ---
      swipeToSlide: false,
      swipe: false,
      touchMove: false,
      useTransform: false,
      // ---
      variableWidth: false,
      className: 'slick-fade',
      // ---
      autoplaySpeed,
      // useCSS: false,
      waitForAnimate: false,
    };
    // ---
    // size setting
    const sizePc = (pcSize !== null && pcSize) ? `${pcSize.toLowerCase()}Size-pc`: '';
    const sizeMb = (mbSize !== null && mbSize) ? `${mbSize.toLowerCase()}Size-mb`: '';
    // ---
    // scrollToSlug
    const scrollSlugClass = (scrollToSlug === null || !scrollToSlug) ? 'is-hide-scroll_btn': 'is-show-scroll_btn';
    // ---
    // console.log('HeroCarousel.render idList', this.idList);
    // ---
    const { introClass } = this.state;
    // ---
    // output
    return (
      <Wrapper
        containerId={containerId}
        containerClass={containerClass}
      >
        <section className={`HeroCarousel ${sizePc} ${sizeMb} ${scrollSlugClass} ${introClass}`}>
          <div
            className="HeroCarousel__slick"
            onTouchStart={this.onTouchStart}
            onTouchEnd={this.onTouchEnd}
            onTouchCancel={this.onTouchCancel}
          >
            <Slider
              settings={settings}
              children={children}
              photoInfoWillOpen={this.photoInfoWillOpen}
              photoInfoWillClose={this.photoInfoWillClose}
              modalWillOpen={this.modalWillOpen}
              modalWillClose={this.modalWillClose}
              heroCarouselSlideId={this.state.heroCarouselSlideId}
              idList={this.idList}
              inHeroCarousel
              sendMessage={this.receiveMessage}
            />
          </div>
          {
            this.renderMask()
          }
          {
            this.renderControls()
          }
          {
            this.renderPager()
          }
        </section>
      </Wrapper>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/hero-carousel/index.jsx